<template>
  <div class="list-inputs-combobox mb-4" v-if="data.class === 'combobox'" :id="`listInputsCombobox-${data.code}`">
    <v-combobox
      v-model="data.value"
      :label="data.text"
      :hint="data.placeholder"
      multiple
      chips
      ref="combobox"
      persistent-hint
      :hide-details="!(!!data.placeholder)"
    >
      <template v-slot:selection="{item}">
        <v-chip color="blue" dark>{{item}}</v-chip>
      </template>
    </v-combobox>
    <v-menu
      :activator="`#listInputsCombobox-${data.code}`"
      ref="itemsMenu"
      bottom
      :offset-y="true"
      :nudge-top="20"
      :close-on-content-click="false"
    >
      <v-list v-show="data.value.length">
        <div class="combobox-list-item" :key="key" v-for="(opt, key) in data.value">
          <v-list-item class="combobox-list-item-container">
            <v-list-item-content>
              <v-list-item-title class="subtitle-2">
                <div v-if="isEditing(key)" class="d-flex">
                  <v-text-field
                    icon="15"
                    class="subtitle-1 p-0 m-0"
                    height="20px"
                    dense
                    solo
                    hide-details
                    v-model="comboboxEditField"
                    autofocus
                    refs="textField"
                  ></v-text-field>
                </div>
                <div v-else>{{opt}}</div>
              </v-list-item-title>
            </v-list-item-content>
            <v-list-item-action class="my-0">
              <div>
                <v-btn x-small depressed fab class="mr-2" @click="editItem(opt, key)">
                  <v-icon v-if="!isEditing(key)">mdi-pencil-outline</v-icon>
                  <v-icon v-else>mdi-check</v-icon>
                </v-btn>
                <v-btn x-small depressed fab @click="delItem(key)">
                  <v-icon>mdi-delete-outline</v-icon>
                </v-btn>
              </div>
            </v-list-item-action>
            <div>
              <v-divider></v-divider>
            </div>
          </v-list-item>
          <v-divider class="mx-3"></v-divider>
        </div>
      </v-list>
    </v-menu>
  </div>
  <div class="list-input-combobox-colorbox" v-else-if="data.class === 'colorbox'">
    <p class="subtitle-2 grey--text text--darken-1 mb-0 mt-3" v-text="data.text"></p>
    <p class="text-caption mb-2 grey--text text--darken-1" v-text="data.placeholder"></p>
    <color-box v-model="data.value" @change="colorboxChanged" />
    <!-- <v-combobox
      v-model="data.value"
      :items="combobox"
      :label="data.text"
      :hint="data.placeholder"
      multiple
      chips
    ></v-combobox> -->
  </div>
</template>

<script>
import ColorBox from './ColorBox.vue';
export default {
  components: { ColorBox },
  name: "Combobox",
  props: {
    data: {
      type: Object,
      required: true
    }
  },
  data() {
    return {
      combobox: [],
      comboboxEditKey: "",
      comboboxEditItem: "",
      comboboxEditField: ""
    };
  },
  methods: {
    comboboxEdit(index, item) {
      if (!this.editingCombobox) {
        this.editingCombobox = item;
        this.editingIndexCombobox = index;
      } else {
        this.editingCombobox = null;
        this.editingIndexCombobox = -1;
      }
    },
    editItem(item, key) {
      if (this.comboboxEditKey === key) {
        let list = [];
        this.data.value.forEach((d, k) => {
          if (k !== key) list.push(d);
          else list.push(this.comboboxEditField);
        });
        this.comboboxEditKey = "";
        this.data.value = list;
      } else {
        this.comboboxEditKey = key;
        this.comboboxEditField = item;
      }
    },
    delItem(key) {
      let list = [];
      this.data.value.forEach((d, k) => {
        if (k !== key) list.push(d);
      });
      this.$set(this.data, "value", list);
    },
    isEditing(key) {
      return this.comboboxEditKey === key;
    },
    colorboxChanged(items) {
      this.$set(this.data, "value", items);
    }
  },
  created() {
    this.combobox = this.data.value;
  },
  watch: {
    // "data.value"(value) {
    //   this.combobox = value;
    // }
  }
};
</script>

<style>
.combobox-combobox {
  position: relative;
}
.combobox-list-item {
  min-height: 30px;
}
.combobox-list-item
  .v-text-field.v-text-field--solo.v-input--dense
  > .v-input__control {
  min-height: auto;
}
.combobox-list-item
  .v-text-field.v-text-field--solo.v-input--dense
  .v-input__slot {
  padding: 0;
}
.combobox-list-item:last-child .v-divider {
  display: none;
}
</style>